<template>
 <div
  class="
   min-h-screen
   py-4
   dark:bg-gray-900 dark:text-gray-200
   bg-gray-100
   pt-20
  "
 >
  <div class="container">
   <button
    class="
     px-3
     py-1.5
     mb-6
     shadow-md
     dark:bg-gray-700
     bg-white
     text-sm
     font-semibold
     tracking-wide
    "
    @click="$router.push('/')"
   >
    BACK
   </button>
   <!-- {{ $route.params.id }} -->

   <div v-if="!load">
    <div v-for="co in c[0]" :key="co">
     <div class="flex gap-10 flex-wrap">
      <img :src="co.flag" alt="" class="w-96" />
      <div class="leading-9 text-lg">
       <h1><span class="font-semibold">Name : </span> {{ co.name }}</h1>
       <h1>
        <span class="font-semibold">Population : </span> {{ co.population }}
       </h1>
       <h1><span class="font-semibold">Region : </span> {{ co.region }}</h1>
       <h1><span class="font-semibold">Name : </span> {{ co.name }}</h1>
      </div>
      <div class="leading-9 text-lg">
       <h1><span class="font-semibold">Area : </span> {{ co.area }}</h1>
       <h1><span class="font-semibold">Capital : </span> {{ co.capital }}</h1>
       <h1 class="mb-2">
        <span class="font-semibold">NativeName : </span> {{ co.nativeName }}
       </h1>
       <div v-for="lg in co.languages" :key="lg" class="inline m-1">
        <span
         class="dark:bg-gray-700 text-sm bg-white shadow-lg py-1 rounded px-3"
         >{{ lg.name }}</span
        >
       </div>
      </div>
     </div>
    </div>
   </div>
   <div v-if="load">
    <Loader />
   </div>
  </div>
 </div>
</template>




<script>
import Loader from "../components/Loader.vue";
export default {
 components: { Loader },
 data() {
  return {
   c: [],
   load: null,
  };
 },
 async created() {
  this.load = true;
  console.log(this.load);
  let res = await fetch(
   `https://restcountries.com/v2/name/${this.$route.params.id}`
  );
  let data = await res.json();
  this.c.push(data);
  this.c[0].map((c) => console.log(c));
  this.load = null;
  console.log(this.$route.params.id);
  console.log(this.load);
 },
};
</script>
